import SelectCustom from '@/components/Helper/Select'

export default {
  components: {
    SelectCustom
  },
  data: () => ({
    showSelect: null,
  }),
  methods: {
    toggleShow(value){
        this.showSelect = this.showSelect == value ? null : value
    },
    closeSelect(){
        this.showSelect = null
    },
  }
}